import { Component, OnInit, signal } from "@angular/core";
import { UserService } from "./services/user.service";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { DataLayerServiceService } from "./data-layer-service.service";
import { CommonService } from "./services/common.service";
import { AppStateService } from "./shared/app-state.service";
import { StateData } from "./shared/common";
import { filter } from "rxjs";
import { AgeGateService } from "./services/age-gate.service";
import { CanonicalService } from "./services/canonical.service";
declare var $: any;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  token: any = "";
  currentRoute: string = '';
  isBrowser = typeof window !== 'undefined';


  constructor(
    private userSrv: UserService,
    private commonService: CommonService,
    private router: Router,
    private _dataLayerService: DataLayerServiceService,
    private activatedRoute: ActivatedRoute,
    private appStateSvc: AppStateService,
    public ageGate: AgeGateService,
    private canonicalService: CanonicalService,


  ) {
    this.commonService.Get('/promo/getPromoProducts').subscribe((res) => {
      if (res['meta']['status']) {
        this.appStateSvc.setState({
          discountedProduct: res['data']['product'],
        });
      }
    });
    // 

    this.appStateSvc.stateData = new StateData();
    localStorage.setItem("optionType", "PICKUP");
    localStorage.setItem("isPickUpOrder", "true");
    // This is for sideNav Component....
    this.getUrlData();
    this.activatedRoute.queryParams.subscribe((res) => {
      this.token = res.token;
      if (this.token != undefined && this.token != null && this.token != "") {
        localStorage.setItem("token", this.token);
      }
    });


    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      const url = event.urlAfterRedirects;
      this.currentRoute = url.startsWith('/') ? url.substring(1) : url;
       const canonicalUrl = 'https://highlifehealth.com' + event.urlAfterRedirects.split('?')[0];
      this.canonicalService.setCanonicalUrl(canonicalUrl);
      if (this.currentRoute == '') this.currentRoute = '/home'
      this.commonService.getSeoContentForHome(this.currentRoute).subscribe((res: any) => {
        if (res) {
          const existingLink = document.querySelector("link[rel='canonical']");
          if (existingLink) {
            existingLink.remove();
          }
          if (res['canonical']) {
            const link = document.createElement('link');
            link.setAttribute('rel', 'canonical');
            link.setAttribute('href', res?.url);
            document.head.appendChild(link);
          } ``
          this.commonService.updateMetaKeywords(res?.title, res?.keywords, res?.description);
        }
      });
    });


    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this._dataLayerService.logPageView(event.url); //call our dataLayer service's page view method to ping home with the url value
      }
    });
  }
  getUrlData() {
    this.commonService.getSiteData();
  }

  ngOnInit() {
     const canonicalUrl = 'https://highlifehealth.com' + this.router.url.split('?')[0];
      this.canonicalService.setCanonicalUrl(canonicalUrl);


    const allReadyLoggedIn = localStorage.getItem("covaUserId");
    if (allReadyLoggedIn) {
      const user = this.getLocalStorage();
      this.afterLogin(user);
    }
  }

  getLocalStorage() {
    const userId = localStorage.getItem("userId");
    const userName = localStorage.getItem("userName");
    const mobileVerified = localStorage.getItem("mobileVerified");
    const documentVerify = localStorage.getItem("documentVerify");

    const user = {
      userId,
      userName,
      mobileVerified,
      documentVerify,
    };
    return user;
  }
  afterLogin(user) {
    this.userSrv.updateUserAuth(true, user);
  }
}
